export enum HUB_TAB {
  PACKAGE = 'Package Hub',
  TEMPLATE = 'Template Hub'
}
